export const locale = {
    lang: 'pl',
    data: {
        'New category': 'Nowa kategoria',
        'Name': 'Nazwa',
        'Parent category': 'Nadrzędna kategoria',
        'ADD': 'Dodaj',
    }
};
